import { cn } from '@rocco/utils/cn';
import { Button } from '@rocco/components/button';

/**
 * The button component for the `ChatBoxSettings` component.
 * @see {@link ChatBoxSettings}
 */
export function ChatBoxSettingsButton({
    children,
    className,
    ...props
}: React.ComponentProps<typeof Button>) {
    return (
        <Button
            className={cn('px-6 leading-tight', className)}
            color="dark"
            size="larger"
            weight="normal"
            {...props}
        >
            {children}
        </Button>
    );
}
